<template>
  <div class="container-fluid p-5 mt-5">
    <TableHeader title="Mis Aditivos" buttonText="CREAR ADITIVO" routeName="create-additive-supply" />

    <SuppliesSearchBar
      inputPlaceholder="Buscar aditivos"
      supplyType="additive"
      @suppliesSearched="renderSearchedSupplies"
      @searchBarCleaned="renderSearchedSupplies"
    />

    <MySupplies
      supplyType="additive"
      :supplyArray="this.additiveSupplies"
      editRoute="edit-additive-supply"
      @supplyRemoved="reloadSupplies"
      @initialyzeCloneFunction="cloneSupply"
    />

    <div class="d-flex justify-content-around pb-1 g-2 mt-2" v-if="!this.loading && this.additiveSupplies.length !== 0">
      <n-button type="info" size="medium" style="font-size: 20px" @click="this.goToPreviousPage" v-show="this.page > 1"> &lt; Pagina anterior </n-button>
      <span type="info" size="medium" style="font-size: 20px" v-show="this.page - 1 === 0"> </span>
      <n-p>Página {{ this.page }} de {{ this.numberOfPages }}</n-p>
      <n-button type="info" quaternary size="medium" style="font-size: 20px" @click="this.goToNextPage" :disabled="this.additiveSupplies.length < 25">
        Pagina siguiente &gt;
      </n-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useMessage, useDialog } from "naive-ui";
import authStore from "../../../store/auth";
import supplyStore from "../../../store/supply";
import MySupplies from "../../../components/SuppliesComponents/mySupplies.vue";
import SuppliesSearchBar from "../../../components/SuppliesComponents/suppliesSearchBar.vue";
import TableHeader from "../../../components/tableHeader.vue";

export default {
  data() {
    return {
      message: useMessage(),
      dialog: useDialog(),
      additiveSupplies: [],
    };
  },
  computed: {
    ...mapState(supplyStore, ["page", "numberOfPages", "loading"]),
    ...mapState(authStore, ["isLoggedIn"]),
  },
  methods: {
    ...mapActions(supplyStore, ["getSupplies", "goToNextPage", "goToPreviousPage", "createSupply"]),
    async cloneSupply(supply) {
      try {
        const { format, presentation, price, provider, type } = supply;

        let data = {
          format,
          presentation,
          price,
          provider,
          type,
          isAvailable: false,
          name: `${supply.name} (copia)`,
        };

        await this.createSupply(data);
        this.message.success("Suministro clonado");
        this.reloadSupplies();
      } catch (e) {
        throw e;
      }
    },
    renderSearchedSupplies(supplies) {
      this.additiveSupplies = [];
      this.additiveSupplies = supplies;
    },
    async reloadSupplies() {
      this.additiveSupplies = [];
      this.additiveSupplies = await this.getSupplies("additive");
    },
  },
  async mounted() {
    if (!this.isLoggedIn) {
      this.message.info("Necesitas iniciar sesión para acceder a esta dirección", { duration: 5000 });
      this.$router.push("/app/login");
    }
    this.additiveSupplies = await this.getSupplies("additive");
  },
  components: { MySupplies, SuppliesSearchBar, TableHeader },
};
</script>

<style scoped></style>
